<template>
  <Modal :value="modalProductIsOpen" :onClose="toggleModalProduct">
    <b-row sm="9">
      <b-col>
        <h3>
          {{ productOfPurchaseOnFiscalEdit.productData.description }}
        </h3>
      </b-col>
    </b-row>
    <div class="mt-3">
      <b-tabs
        active-nav-item-class="font-weight-bold"
        content-class="mt-3"
        align="center"
        v-model="tabIndex"
        fills
        justified
      >
        <b-tab active :title-link-class="linkClass(0)">
          <template #title>
            <b-spinner v-if="loadingTabProduct" type="border" small />
            Produto
          </template>
          <ProductTab ref="productTab" />
        </b-tab>
        <b-tab :title-link-class="linkClass(1)">
          <template #title>
            <b-spinner v-if="false" type="border" small />
            ICMS ST
          </template>
          <STTab ref="stTab" />
        </b-tab>
        <b-tab :title-link-class="linkClass(2)">
          <template #title>
            <b-spinner v-if="loadingTabPurchase" type="border" small />
            ICMS/IPI
          </template>
          <IcmsIpiTab ref="icmsIpiTab" />
        </b-tab>
        <b-tab :title-link-class="linkClass(3)">
          <template #title>
            <b-spinner v-if="loadingTabPurchase" type="border" small />
            PIS/COFINS
          </template>
          <PisCofinsTab ref="pisCofinsTab" />
        </b-tab>
        <b-tab :title-link-class="linkClass(4)" v-if="!disabledTab">
          <template #title>
            <b-spinner v-if="false" type="border" small />
            Observação
          </template>
          <ObservationTab />
        </b-tab>
      </b-tabs>
    </div>
    <br />
    <b-row align="center">
      <b-col>
        <Button type="cancel" @click="toggleModalProduct()">
          <Close class="mb-1" title="Cancelar" /> Cancelar
        </Button>
        <Button @click="handleSave()" type="success">Salvar</Button>
      </b-col>
    </b-row>
  </Modal>
</template>

<script>
import { Modal } from '@/components';
import { mapActions, mapGetters, mapState } from 'vuex';
import { Button } from '@/components/Form';
import { CalcTypesPurchaseEnum } from '@/modules/Fiscal/enums/CalcTypesEnum';
import Close from 'vue-material-design-icons/Close';
import FormatMixin from '@/modules/Application/mixins/FormatMixin';
import STTab from './Tabs/STTab.vue';
import IcmsIpiTab from './Tabs/IcmsIpiTab.vue';
import PisCofinsTab from './Tabs/PisCofinsTab.vue';
import ObservationTab from './Tabs/ObservationTab.vue';
import ProductTab from './Tabs/ProductTab.vue';
import * as editParser from '../../../parsers/edit-product';
import * as saveParser from '../../../parsers/save-product';

export default {
  name: 'modalFiscalProduct',
  mixins: [FormatMixin],
  components: {
    Modal,
    STTab,
    IcmsIpiTab,
    PisCofinsTab,
    ObservationTab,
    Button,
    ProductTab,
    Close,
  },
  data() {
    return {
      disabledTab: true,
      tabIndex: 0,
      arrTabs: ['productTab', 'stTab', 'icmsIpiTab', 'pisCofinsTab'],
    };
  },
  computed: {
    ...mapState('purchase', [
      'purchase',
      'products',
      'productOfPurchaseOnFiscalEdit',
    ]),
    ...mapState('componentsPurchase', [
      'modalProductIsOpen',
      'loadingTabProduct',
      'loadingTabPurchase',
    ]),
    ...mapState('product', ['productInventory']),
    ...mapGetters('purchase', ['decimalConfiguration']),
  },
  methods: {
    ...mapActions('purchase', [
      'totalCalcPurchase',
      'setProductOfPurchaseOnFiscalEdit',
      'setProductOnPurchaseCollection',
      'setUnitOfMeasureById',
    ]),
    ...mapActions('componentsPurchase', ['toggleModalProduct']),
    isValidProduct() {
      this.$refs.productTab.$v.$touch();
      this.$refs.stTab.$v.$touch();
      return !this.arrTabs.some((e) => {
        if (this.$refs[e]?.$v?.$error) {
          return true;
        }
        return false;
      });
    },
    async handleSave() {
      if (!this.isValidProduct()) return false;

      const { productData } = saveParser.productTabInformationToSave(
        this.productOfPurchaseOnFiscalEdit,
      );
      const { fiscal } = saveParser.fiscalInformationToSave(
        this.productOfPurchaseOnFiscalEdit,
      );
      const params = {
        productOfPurchaseOnFiscalEdit: {
          ...this.productOfPurchaseOnFiscalEdit,
          productData: { ...productData },
          fiscal: { ...fiscal },
        },
        products: this.products,
      };

      await this.setProductOnPurchaseCollection(params);
      await this.totalCalcPurchase({
        calcTypes: [
          CalcTypesPurchaseEnum.TOTAL_ATTRIBUTES,
          CalcTypesPurchaseEnum.TOTAL_COMMON,
          CalcTypesPurchaseEnum.TOTAL_DESC_BASED_ON_ITEM,
          CalcTypesPurchaseEnum.TOTAL_NF,
        ],
      });
      await this.toggleModalProduct();
      return this.$alert.success('Informações salvas!');
    },
    linkClass(idx) {
      if (this.$refs[this.arrTabs[idx]]?.$v?.$error) return ['text-danger'];
      if (this.tabIndex === idx) return ['color-default'];
      return ['text-muted'];
    },
  },
  watch: {
    async modalProductIsOpen() {
      if (!this.modalProductIsOpen) {
        return;
      }

      const { fiscal } = this.productOfPurchaseOnFiscalEdit;
      const { productData } = editParser.productTabInformationToEdit(
        this.productOfPurchaseOnFiscalEdit,
        this.decimalConfiguration,
      );
      const { values } = editParser.fiscalValuesToEdit(
        this.productOfPurchaseOnFiscalEdit,
      );

      await this.setProductOfPurchaseOnFiscalEdit({
        ...this.productOfPurchaseOnFiscalEdit,
        productData: { ...productData },
        fiscal: {
          ...fiscal,
          values: { ...values },
        },
      });
    },
  },
};
</script>
